var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconMessage = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M2.01 0a2 2 0 0 0-2 1.998l-.01 18L4 16h14c1.103 0 2-.897 2-2V2c0-1.103-.897-2-2-2zm0 2H18v12H3.172l-1.168 1.17zM5 7v2h2V7zm4 0v2h2V7zm4 0v2h2V7z"
})));
export default SvgIconMessage;